import type React from 'react';
import { EcardActions } from './views/ecardactions/EcardActions.tsx';
import { QuickActions } from './views/quickactions/QuickActions.tsx';

// A web-AIS session has neither the quick actions nor the e-card
export const HeaderActions: React.FC<{ aisSession: boolean }> = ({ aisSession }) =>
  aisSession ? null : (
    <>
      <QuickActions />
      <EcardActions />
    </>
  );
